<template>
  <header v-if="!isInWxapp" class="simple-header van-hairline--bottom">
    <i v-if="!isback" class="nbicon nbfanhui" @click="goBack"></i>
    <i v-else>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</i>
    <div class="simple-header-name">{{ title }}</div>
    <i class="nbicon nbmore"></i>
  </header>
  <div v-if="!isInWxapp" class="block" />
</template>

<script>
import { ref, onMounted, watchEffect } from 'vue'
import { useRouter } from 'vue-router'
import usePage from '@/hooks/usePage'

export default {
  props: {
    name: {
      type: String,
      default: ''
    },
    back: {
      type: String,
      default: ''
    },
    noback: {
      type: Boolean,
      default: false
    }
  },
  emits: ['callback'],
  setup(props, ctx) {
    const isback = ref(props.noback)
    const router = useRouter()
    const isInWxapp = ref(false)
    const title = ref(props.name || document.title)
    const { isMiniProgram } = usePage()

    const goBack = () => {
      if (!props.back) {
        router.go(-1)
      } else {
        router.push({ path: props.back })
      }
      ctx.emit('callback')
    }

    onMounted(async () => {
      isInWxapp.value = await isMiniProgram()
    })

    watchEffect(() => {
      if (props.name) document.title = props.name
    })

    return {
      goBack,
      isback,
      isInWxapp,
      title
    }
  }
}
</script>

<style lang="less" scoped>
@import '../common/style/mixin';
.simple-header {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10000;
  .fj();
  .wh(100%, 44px);
  line-height: 44px;
  padding: 0 10px;
  .boxSizing();
  color: #252525;
  background: #fff;
  .simple-header-name {
    font-size: 14px;
  }
}
.block {
  height: 44px;
}
</style>
